var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4CovivaRouter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 56a4 4 0 01-4 4H16.88A4 4 0 0113 56.35V20v-.52A4 4 0 0116.88 16H59a4 4 0 014 4v36zm-4-36H17v36h42V20zM29 30h17a2 2 0 000-4H29a2 2 0 000 4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Coviva_router.d84feb9c.svg";
export { SvgA4CovivaRouter as ReactComponent };